import { KoDate, KoForm, KoFormBuilder,  KoInput, KoSelect, KoTextArea, KoTimePicker } from 'packages';
import KoIcon from '@kwapio/icons';
import { useCallback, useEffect } from 'react';
import { SPRINTSTATUS } from '../../../../../shared/commonConstants';
import styles from './curd.module.scss';
import SprintGoalCrud from './sprintGoal';
import SprintLeavePlan from './sprintLeavePlan';
import { useSelector } from 'react-redux';
function SprintCrud({ form, handleFinish, initialValues , profile}) {
  const holidays = useSelector(state => state?.holidays);

  useEffect(() => {
    if (!initialValues || Object.keys(initialValues).length === 0) {
      form.resetFields();
    } else {
      form.setFieldsValue(initialValues);
    }
  }, [initialValues, form]);

  const handleSubmit = useCallback(values => {
    values['status'] = values['status'] ? values['status'] : 1;
    handleFinish(values);
  });


  const StatusType = ({ value, onChange }) =>
    <KoSelect value={value}
      defaultValue={1}
      onChange={v => onChange(v)}
      showSearch
      placeholder='Select issue type'
      options={SPRINTSTATUS}
      optionRender={(option) => (
        <div className={styles.iconWithLabel} role="img" aria-label={option.data.label}>
          {option.data.value === 1 && <KoIcon name="ActiveSprintOutlined" />}
          {option.data.value === 2 && <KoIcon name="ActiveSprintOutlined" />}
          {option.data.value === 3 && <KoIcon name="LastSprintOutlined" />}
          {option.data.value === 4 && <KoIcon name="ClosedSprintOutlined" />}
          {option.data.value === 5 && <KoIcon name="ActiveSprintOutlined" />}
          {option.data.label}
        </div>
      )}
    />;

  const handleEntryFinish = (values) => {
    handleSubmit(values);
  };

  const ItemTable = ({ value, onChange }) =>
    <SprintGoalCrud form={form} initialValues={initialValues} handleFinish={handleEntryFinish} />;

  const ItemSLPTable = ({ value, onChange }) =>
    <SprintLeavePlan form={form} initialValues={initialValues} handleFinish={handleEntryFinish} profile={profile}/>;
    
  const Time = ({ value, onChange }) => {
    const handleChange = (v) => {
      const formattedValue = v instanceof Date ? v.toTimeString().slice(0, 5) : v;
      onChange(formattedValue);
    };

    const formattedValue = value ? (value instanceof Date ? value.toTimeString().slice(0, 5) : value) : '';

    return (
      <KoTimePicker
        changeOnScroll
        needConfirm={false}
        allowClear={false}
        value={formattedValue}
        format='HH:mm'
        onChange={handleChange}
      />
    );
  };

  const CarryForward = ({ value, onChange }) =>
    <KoSelect value={value}
      onChange={v => onChange(v)}
      showSearch
      placeholder='Select'
      options={[{
        label: 'Yes',
        value: true
      }, {
        label: 'No',
        value: false
      }]?.map((time) => ({
        label: time?.label,
        value: time?.value
      }))}
    />;

  const Date = ({ value, onChange }) =>
    <KoDate value={value} dateFormat = {'DD-MMM-YYYY'}
      holidays={holidays['data']}
      userLeave={false}
      onChange={v => onChange(v)} daysAgo={0}/>;

  const meta = {
    columns: 4,
    formItemLayout: null,
    initialValues,
    colon: true,
    fields: [
      {
        key: 'name', placeholder: 'Enter sprint name', label: 'Sprint Name', colSpan: 2,
        widget: ({ value, onChange }) => (
          <KoForm.Item>
            <KoInput
              value={value}
              onChange={onChange}
              disabled={initialValues?.name}
              placeholder="Enter sprint name"
            />
          </KoForm.Item>
        ),
        rules: [
          {
            required: true,
            message: `Please enter summary.`,
            disable: true
          }
        ]
      },
      {
        key: 'status', label: 'Sprint status', colSpan: 2,
        widget: StatusType,
        forwardRef: true
      },
      {
        key: 'startDate', label: 'Start date', colSpan: 2,
        widget: Date,
        rules: [
          {
            required: true,
            message: `Please select start date.`,
            disable: true
          }
        ]
      },
     
      {
        key: 'endDate', label: 'End date', colSpan: 2,
        widget: Date,
        rules: [
          {
            required: true,
            message: `Please select end date.`,
            disable: true
          }
        ]
      },

      {
        key: 'time', placeholder: 'Time', label: 'Sprint Auto-Close (Time)', colSpan: 2, widget: Time
      },
      {
        key: 'carryForward', label: 'Carry Over to Retrospective?', colSpan: 2, widget: CarryForward
      },
      {
        key: 'sprintGoal', label: 'Sprint Goal', colSpan: 4,
        widget: ItemTable,
        forwardRef: true
      },
      {
        key: 'leavePlan', label: 'Leave Plan', colSpan: 4,
        widget: ItemSLPTable,
        forwardRef: true
      },
      {
        key: 'description', widget: KoTextArea, label: 'Description', colSpan: 4, placeholder: 'Enter project description'
      }

    ]
  };


  return (
    <div className={styles.wrapper}>
      <KoForm form={form} layout="vertical" onFinish={handleSubmit}
        onSubmit={handleSubmit}>
        <KoFormBuilder form={form} meta={meta} />
      </KoForm>
    </div>
  );
};

export default SprintCrud;